import React from 'react';

export default function PrivateSchoolModalContent() {
  return (
    <>
      <p>
        An institution owned and operated by one or more nonprofit corporations
        or associations, where no part of the net earnings benefit any private
        shareholder or individual.
      </p>
    </>
  );
}
